export const GET_MUSICIAN_GROUPS = 'GET_MUSICIAN_GROUPS';
export const GET_MUSICIAN_GROUP_BY_ID = 'GET_MUSICIAN_GROUP_BY_ID';
export const UPDATE_MUSICIAN_GROUP = 'UPDATE_MUSICIAN_GROUP';
export const DELETE_MUSICIAN_GROUP = 'DELETE_MUSICIAN_GROUP';
export const CREATE_MUSICIAN_GROUP = 'CREATE_MUSICIAN_GROUP';
